export { ProductDetailV2 } from './ProductDetailV2';
